/**
 * Convert a byte count to a human-readable string.
 *
 * @param {number} bytes
 * @param {number} [decimals=1]
 * @returns {string} e.g. "4.2 KB", "12.4 MB"
 */
export default function formatBytes(bytes, decimals = 1) {
  if (bytes === 0) return '0 Bytes';
  if (bytes == null || Number.isNaN(bytes)) return '—';

  const k = 1000; // use SI (decimal) units like the rest of the app
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / k ** i;

  return `${value.toFixed(decimals)} ${sizes[i]}`;
}
